import { appTheme } from '@carsland-web/theme'
import { ThemeProvider } from '@pasteltech/theme-provider'
import { ReactNode } from 'react'
// eslint-disable-next-line import/no-internal-modules
import { InitContainer } from './src/component'
// eslint-disable-next-line import/no-internal-modules
import { GlobalStyle } from './src/global-context'

// Wraps every page in a component
export const wrapPageElement = ({ element }: { element: ReactNode }) => {
  return (
    <ThemeProvider initialTheme={appTheme}>
      <InitContainer>
        <GlobalStyle />
        {element}
      </InitContainer>
    </ThemeProvider>
  )
}
